__turbopack_context__.v({
  "brandFilterCheckbox": "PyYxwG_brandFilterCheckbox",
  "brandFilterContent": "PyYxwG_brandFilterContent",
  "brandFilterDropdownContents": "PyYxwG_brandFilterDropdownContents",
  "brandFilterDropdownHeading": "PyYxwG_brandFilterDropdownHeading",
  "brandFilterNoResultsText": "PyYxwG_brandFilterNoResultsText",
  "brandFilterSearchContainer": "PyYxwG_brandFilterSearchContainer",
  "brandFilterSearchInput": "PyYxwG_brandFilterSearchInput",
  "listContainer": "PyYxwG_listContainer",
});
